type ComplianceSpiderTickProps = {
    x: number;
    y: number;
    payload: {
        value: string;
        coordinate: number;
    };
};

const ComplianceSpiderTick = ({
    x,
    y,
    payload: { value, coordinate },
}: ComplianceSpiderTickProps) => {
    let words = value.length > 12 ? value.split(" ") : [value];

    if (words.length === 3 && words[1] === "&") {
        if (words[0].length <= 10) {
            words = [`${words[0]} &`, words[2]];
        } else if (words[2].length <= 10) {
            words = [words[0], `& ${words[2]}`];
        }
    }

    const isTop = coordinate > 89;
    const isBottom = coordinate < -89 && coordinate > -91;
    const textAnchor =
        isTop || isBottom ? "middle" : coordinate > -91 ? "start" : "end";

    return (
        <g transform={`translate(${x},${y})`}>
            <text x={0} y={0} dy={16} fill="#666">
                {words.map((word, index) => (
                    <tspan
                        key={word}
                        textAnchor={textAnchor}
                        x="0"
                        dy={index * 15 + (isBottom && index === 0 ? 10 : 0)}
                        className="text-xs"
                    >
                        {word}
                    </tspan>
                ))}
            </text>
        </g>
    );
};

export default ComplianceSpiderTick;
